import { z } from 'zod';

export const RealizedMarginQuerySchema = z
  .object({
    from: z.iso.datetime(),
    to: z.iso.datetime(),
  })
  .refine((value) => Date.parse(value.from) <= Date.parse(value.to), {
    message: 'from must be less than or equal to to',
    path: ['from'],
  });
export type RealizedMarginQuery = z.infer<typeof RealizedMarginQuerySchema>;

export const RealizedMarginBucketSchema = z.object({
  key: z.string().nullable(),
  saleCents: z.string(),
  costCents: z.string(),
  marginCents: z.string(),
});
export type RealizedMarginBucket = z.infer<typeof RealizedMarginBucketSchema>;

export const RealizedMarginUncostedLineSchema = z.object({
  itemId: z.uuid(),
  itemType: z.string(),
  priceOrigin: z.string().nullable(),
});
export type RealizedMarginUncostedLine = z.infer<typeof RealizedMarginUncostedLineSchema>;

export const RealizedMarginTotalsSchema = z.object({
  saleCents: z.string(),
  costCents: z.string(),
  marginCents: z.string(),
});
export type RealizedMarginTotals = z.infer<typeof RealizedMarginTotalsSchema>;

export const RealizedMarginReportSchema = z.object({
  periodBasis: z.literal('ITEM_FINISHED'),
  from: z.iso.datetime(),
  to: z.iso.datetime(),
  totals: RealizedMarginTotalsSchema,
  byItemType: z.array(RealizedMarginBucketSchema),
  byPriceOrigin: z.array(RealizedMarginBucketSchema),
  byMechanic: z.array(RealizedMarginBucketSchema),
  bySeller: z.array(RealizedMarginBucketSchema),
  uncostedLines: z.array(RealizedMarginUncostedLineSchema),
});
export type RealizedMarginReport = z.infer<typeof RealizedMarginReportSchema>;
